<template>
  <div>
    <el-page-header @back="goBack" content="测评结果设置"> </el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
            >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
              >共 <i>{{ detalisObj.questions }}</i
              >题</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="topic-outer" v-if="jzIsShow">
      <div class="appraisal-center fonts marr">
        <div>
          第一次维护，需要初始化基准。该操作请在维度和基准维护完成后再操作！
          <div class="initialize">
            <el-button type="primary" plain @click="initJZ"
              >初始化基准</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="topic-outer" v-if="jzIsHiden" style="padding-bottom: 30px">
      <div class="appraisal-center fonts marr">
        <el-tabs
          tab-position="left"
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane
            v-for="item in initJZData"
            :key="item.examResultId"
            :label="item.name+'\n'+item.code"
            :name="item.examResultId.toString()"
          >
          </el-tab-pane>
          <div>
            <div class="public-dialog-form">
              <el-form
                ref="ruleForm"
                :rules="rules"
                :model="params"
                label-width="85px"
              >
                <el-form-item label="性格名称" prop="title">
                  <el-input v-model="params.title"></el-input>
                </el-form-item>
                <el-form-item label="详情" prop="content">
                  <quill-editor
                    ref="editorComp1"
                    class="editor"
                    v-model="params.content"
                    :options="editorOption"
                    clearable
                  >
                  </quill-editor>
                </el-form-item>
                <el-form-item label="情感 Tips" prop="descr">
                  <quill-editor
                    ref="editorComp2"
                    class="editor"
                    v-model="params.descr"
                    :options="editorOption"
                    clearable
                  >
                  </quill-editor>
                </el-form-item>
                <el-form-item label="小优点" prop="suggest">
                  <quill-editor
                    ref="editorComp3"
                    class="editor"
                    v-model="params.suggest"
                    :options="editorOption"
                    clearable
                  >
                  </quill-editor>


                </el-form-item>

                <el-form-item label="适合的另一半" prop="guideSuggest">
                  <quill-editor
                      ref="editorComp4"
                      class="editor"
                      v-model="params.guideSuggest"
                      :options="editorOption"
                      clearable
                  >
                  </quill-editor>


                </el-form-item>

                <el-form-item label="更好的爱情" prop="suggest2">
                  <quill-editor
                      ref="editorComp5"
                      class="editor"
                      v-model="params.suggest2"
                      :options="editorOption"
                      clearable
                  >
                  </quill-editor>


                </el-form-item>
              </el-form>
              <span slot="footer" class="public-dialog-footer">
                <el-button size="medium" @click="handleEdit('reset')"
                  >重 置</el-button
                >
                <el-button
                  size="medium"
                  type="primary"
                  @click="handleEdit('add')"
                  >提 交</el-button
                >
              </span>
            </div>
          </div>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "code-block"],

              [{ header: 1 }, { header: 2 }], // custom button values
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }], // superscript/subscript
              [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              [{ direction: "rtl" }], // text direction

              [{ size: ["small", false, "large", "huge"] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],

              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ font: [] }],
              [{ align: [] }],
              ["link", "image", "video"],
              ["clean"], // remove formatting button
            ],
            handlers: {
              shadeBox: null,
              insertMetric: function () {
                //方法体
                alert(1);
              },
            },
          },
        },
      },
      rules: {
        title: [
          {
            required: true,
            message: "请填写性格名称",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写详情",
            trigger: "blur",
          },
        ],
        descr: [
          {
            required: true,
            message: "请填写情感 Tips",
            trigger: "blur",
          },
        ],
        suggest: [
          {
            required: true,
            message: "请填写小优点",
            trigger: "blur",
          },
        ],
        guideSuggest: [
          {
            required: true,
            message: "请填写适合的另一半",
            trigger: "blur",
          },
        ],
        suggest2: [
          {
            required: true,
            message: "请填写更好的爱情",
            trigger: "blur",
          },
        ],
      },
      detalisObj: {},
      loading: false,
      jzIsShow: true,
      jzIsHiden: false,
      initJZData: [],
      activeName: "",
      params: {},
    };
  },
  created() {
    this.getAppraisalData();
    this.initJZ();

    // setTimeout(() => {
    //   this.$refs.editorComp.quill.enable(true); //2秒之后可以点击（聚焦）
    // }, 2000);
  },
  methods: {
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;

      const { data: resData } = await this.$get(
        `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 初始化基准
     */
    async initJZ() {
      this.loading = true;

      const { data: resData } = await this.$post(
        `exam/result/init/datum/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.jzIsShow = false;
        this.jzIsHiden = true;
      }
      resData.data.map(item=>{
        item.examResultContent = item.name+'\n'+item.code
      })
      this.initJZData = resData.data;
      let id = resData.data[0].examResultId;
      this.activeName = id.toString();
      this.params.examResultId = id;
      this.resultDetails(id);
    },
    handleEdit(type) {
      if (type == "add") {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) return;
            this.$confirm("确认保存数据, 是否继续?", "提示", {
              type: "info",
            }).then(async () => {
              const {data: resData} = await this.$put(
                  "exam/result/info",
                  this.params,
                  {
                    headers: {
                      isLoading: true,
                    },
                  }
              );
              if (resData.result != 200) return;
              this.$message.success("提交成功!");
            })
        });
      }else if(type == "reset"){
        this.$confirm("确认重置当前数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post(
              "exam/result/init/datum/"+this.$route.query.examId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.$refs.ruleForm.resetFields();
          this.params = {}
          this.$message.success("重置成功!");
        })
      }
    },

    async resultDetails(examResultId) {


      const { data: resData } = await this.$get(
        `exam/result/info/${examResultId}`,
        {
          headers: {
            isLoading: true,
          },
        }
      );

      if (resData.result != 200) return;
      this.params = resData.data;
      // console.log(this.$refs.editorComp1)
      this.$refs.editorComp1.quill.enable(false); //刚开始时，不聚焦
      this.$refs.editorComp2.quill.enable(false); //刚开始时，不聚焦
      this.$refs.editorComp3.quill.enable(false); //刚开始时，不聚焦
      this.$refs.editorComp4.quill.enable(false); //刚开始时，不聚焦
      this.$refs.editorComp5.quill.enable(false); //刚开始时，不聚焦
      setTimeout(() => {
        this.$refs.editorComp1.quill.enable(true); //2秒之后可以点击（聚焦）
        this.$refs.editorComp2.quill.enable(true); //2秒之后可以点击（聚焦）
        this.$refs.editorComp3.quill.enable(true); //2秒之后可以点击（聚焦）
        this.$refs.editorComp4.quill.enable(true); //2秒之后可以点击（聚焦）
        this.$refs.editorComp5.quill.enable(true); //2秒之后可以点击（聚焦）
      }, 2000);
    },

    handleClick(tab, event) {
      this.$refs.ruleForm.resetFields();
      this.params = {}
      this.params.examResultId = parseInt(tab.name);
      this.resultDetails(tab.name);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  line-height: normal !important;
  margin-bottom: 30px;
}
.initialize {
  margin-top: 20px;
}
.appraisal-title {
  color: #3a3a3a;
}
.appraisal-center {
  width: 90%;
  margin: 0 auto;
}
.fonts {
  font-size: 14px;
}
.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}
.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.fl1 {
  flex: 1;
  -webkit-flex: 1;
}
.glay {
  color: #8492a6;
  i {
    font-style: normal;
    color: #f56c6c;
  }
}
.pub-line {
  margin-top: 30px;
}
.pub-marr {
  margin-top: 20px;
}
.marr {
  margin-top: 30px;
}
.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}
.subject {
  color: #8492a6;
  margin-left: 10px;
  i {
    font-style: normal;
    color: #f56c6c;
  }
}
.activeBg {
  background: #b3d8ff;
  color: #fff;
}
.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

</style>
<style>
.topic-outer .el-tabs__item{
  white-space: pre-wrap;
  text-align: center !important;
  line-height: 20px;
  height: 46px !important;

}
.topic-outer .el-form-item{
  margin-bottom: 40px;
}
.topic-outer .ql-container.ql-snow{
  height: 260px;
}
.topic-outer .quill-editor.editor{
  margin-bottom: 0;
}
</style>